{
  "provision_server": "Installazione del server",
  "decommission_server": "Scollegamento del server",
  "create_instance": "Creazione dell’istanza",
  "delete_instance": "Rimozione dell’istanza",
  "restore_instance": "Ripristino da backup",
  "backup_instance": "Backup dell’istanza",
  "start_instance": "Avvio dell’istanza",
  "stop_instance": "Arresto dell’istanza",
  "restart_instance": "Riavvio dell’istanza",
  "configure_instance": "Riconfigurazione dell’istanza",
  "update_instance": "Aggiornamento di Odoo su",
  "create_staging": "Copia di prova di",
  "refresh_staging": "Ricarico della copia",
  "restore_in_place": "Ripristino in produzione di",
  "test_restore": "Prova di ripristino di",
  "set_domain": "Collegamento del dominio",
  "remove_domain": "Rimozione del dominio",
  "dr_run": "Ripristino d’emergenza",
  "connect_source": "Collegamento della macchina CloudPepper",
  "inventory_source": "Inventario della macchina CloudPepper",
  "disconnect_source": "Scollegamento della macchina CloudPepper",
  "migration_trial": "Prova di trasloco",
  "migration_cutover": "Trasloco",
  "migration_revert": "Ritorno su CloudPepper",
  "import_instance": "Import da CloudPepper di",
  "backup_retention": "Pulizia dei backup vecchi",
  "backup_verify": "Verifica di un backup",
  "backup_scheduler": "Pianificazione dei backup",
  "backup_servers": "Backup dei certificati dei server",
  "restore_test_scheduler": "Giro delle prove di ripristino",
  "metrics_retention": "Pulizia delle metriche",
  "ping": "Controllo di funzionamento"
}
